import { PortalSelectedLoan } from '../../App';

export const getTotalAmountDue = (loan: PortalSelectedLoan): number => {
  const {
    currentSnapshot: {
      totalAmountRemainingFromBorrower,
      maturityConfig: { isMaturing },
      expectedPayoffTotal,
      isFullInterestOnlyLoan,
    },
  } = loan;

  return isMaturing && !isFullInterestOnlyLoan && totalAmountRemainingFromBorrower === 0
    ? expectedPayoffTotal
    : totalAmountRemainingFromBorrower;
};
